module.exports = __webpack_public_path__ + "kg.99318e86.svg";